import { Collapse, CollapseDropdownContainer } from '@trarc/pc-shared';
import styled from 'styled-components';

export const QuestionnaireContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex-shrink: 0;
  padding: 0.25rem;
`;

export const QuestionnaireSection = styled(Collapse)`
  width: 100%;
  ${CollapseDropdownContainer} {
    padding: 0 1rem;
  }
`;
